import React, { useEffect, useState } from 'react'
import Table from '../components/core/table/Table'
import API from '../methods/API'
import leadMethods from '../methods/leadMethods'
import CONSTANTS from '../CONSTANTS'
// import data1 from "../assets/demo/mock_leadRes.json"

const IMLeads = () => {
    const [leads, setLeads] = useState([])

    useEffect(() => {
        getImLeads()
    }, [])

    const getImLeads = async () => {
        // setLeads(data1)
        await API.getLeads().then((data) => {
            setLeads(data.filter(item=>!!item.QUERY_TIME))
        }).catch((err) => {
            console.log(err)
            // setLeads(sampleList)
        })
    }

        return (
            <div className=''>
                
                    <Table
                        colms={CONSTANTS.IMLEAD_LIST_TABLE.HEADS}
                        items={leadMethods.getModifiedIMLeadList(leads)}
                        heading={CONSTANTS.IMLEAD_LIST_TABLE.TITLE}
                    />
                
            </div>
        )

}

export default IMLeads
